import { post } from 'libs/GrebbCommerceAPI/util';

export default async (basketId, voucherCode) => {
    // @todo: refactor ? currently just sending empty data, maybe refactor so we send voucher_code
    // in data instead of as now part of the url.
    const data = {};

    return await post(`/basket/${basketId}/voucher/${encodeURIComponent(voucherCode)}`, data);
};
